import { useEffect, useRef, useState } from 'react';
import useTranscripts from 'api/hooks/useTranscripts';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import getUrlParam from 'components/Dashboard/utilities/getUrlParam';
import { useSearchParams } from 'react-router-dom';
import CustomScrollbar from 'components/Common/CustomScrollbar';
import { useHeightContainer } from 'components/Dashboard/utilities/useHeightContainer';
import filterTranscriptsByCategory from 'components/Dashboard/Transcripts/filterTranscriptsByCategory';

const CreateTranscripts = (props) => {
  const { openState, activeDebateState, activeSectionState, dateState } = props;
  const { setIsOpen } = openState;
  const { setActiveDebate } = activeDebateState;
  const { activeSection } = activeSectionState;
  const { date } = dateState;
  const [isLoading, setIsLoading] = useState(false);

  const [events, setEvents] = useState([]);
  const [debates, setDebates] = useState([]);

  const { getTranscriptsEvents, getTranscriptsDebates } = useTranscripts();
  const [searchParams, setSearchParams] = useSearchParams();
  const [heightContainer, containerRef] = useHeightContainer();

  const initialLoad = useRef(null);
  initialLoad.current = async (signal) => {
    try {
      setIsLoading(true);

      const sortParam = getUrlParam('sort');
      const next = new URLSearchParams(searchParams);
      if (!!sortParam) {
        next.delete('sort');
      }
      setSearchParams(next);
      const [eventsData, debatesData] = await Promise.all([
        getTranscriptsEvents({ signal, isoDate: date }),
        getTranscriptsDebates({ signal, isoDate: date }),
      ]);
      if (!!eventsData || !!debatesData) {
        setEvents(eventsData ?? []);
        setDebates(debatesData ?? []);
        setIsLoading(false);
      }
    } catch (error) {}
  };

  useEffect(() => {
    const controller = new AbortController();
    initialLoad.current(controller.signal);
    return () => {
      controller.abort('Transcripts page cancelled by the user.');
    };
  }, [date]);

  const filteredItems = filterTranscriptsByCategory([...events, ...debates], activeSection);

  return (
    <div ref={containerRef}>
      <CustomScrollbar
        className={`main-content-scrollbar`}
        style={{ height: `${heightContainer}px` }}
        maximalThumbYSize={100}
      >
        <div className='p-4 pt-lg-5 px-lg-5 pb-2'>
          <p className='mb-0 title-h5-m-bold'>
            Choose an event below to create a transcript and tailored report for it
          </p>
        </div>
        <div className='px-4 pb-4 px-lg-5'>
          {isLoading ? (
            <SkeletonTheme baseColor='#fff'>
              {Array(10)
                .fill()
                .map((item, index) => {
                  return (
                    <div key={index} className='mb-2'>
                      <Skeleton height={19} width={`60%`} />
                    </div>
                  );
                })}
            </SkeletonTheme>
          ) : (
            <ul className='policy-list px-0 pb-2'>
              {filteredItems.length === 0 ? (
                <p className='mb-0 light-60-text pt-2'>No events or debates with transcripts available</p>
              ) : (
                <>
                  {filteredItems.map((item) => (
                    <li
                      className='my-2 pointer general-link'
                      key={item.parliamentEventId ?? item.id}
                      onClick={() => {
                        setActiveDebate(item);
                        setIsOpen(true);
                      }}
                    >
                      {item.debateTitle ?? item.title}
                    </li>
                  ))}
                </>
              )}
            </ul>
          )}
        </div>
      </CustomScrollbar>
    </div>
  );
};

export default CreateTranscripts;
